import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";
import { resolveImageUrl } from "@/components/ImageUploader";

export const StatusBadge = ({ status }) => {
  const label = status === "tamamlandi" ? "Tamamlandı" : "Devam Ediyor";
  const styles =
    status === "tamamlandi"
      ? "bg-[var(--navy)] text-[var(--gold)] border-[var(--gold)]/40"
      : "bg-[var(--gold)] text-[var(--navy)] border-[var(--gold)]";
  return (
    <span
      data-testid={`status-${status}`}
      className={`inline-flex items-center gap-1.5 text-[0.65rem] tracking-[0.22em] uppercase px-3 py-1 border ${styles}`}
    >
      <span className="w-1 h-1 rounded-full bg-current" />
      {label}
    </span>
  );
};

export const ProjectCard = ({ project, variant = "default" }) => {
  const isWide = variant === "wide";
  return (
    <Link
      to={`/projeler/${project.slug}`}
      data-testid={`project-card-${project.slug}`}
      className="group block lux-card relative overflow-hidden"
    >
      <div className={`relative overflow-hidden ${isWide ? "aspect-[16/10]" : "aspect-[4/5]"}`}>
        <img
          src={resolveImageUrl(project.hero_image)}
          alt={project.title}
          className="w-full h-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-110"
        />
        {/* Darker base overlay so cards read clearly */}
        <div className="absolute inset-0 bg-[var(--navy)]/35" />
        <div className="absolute inset-0 bg-gradient-to-t from-[var(--navy)] via-[var(--navy)]/65 to-[var(--navy)]/15" />
        <div className="absolute top-4 left-4">
          <StatusBadge status={project.status} />
        </div>
        <div className="absolute top-4 right-4 w-10 h-10 border border-[var(--gold)]/60 rounded-tr-[40px] opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

        <div className="absolute inset-x-0 bottom-0 p-6 lg:p-8 text-white">
          <h3 className="font-serif-luxe text-2xl lg:text-3xl leading-tight text-white" style={{ textShadow: "0 2px 16px rgba(10, 25, 47, 0.7)" }}>{project.title}</h3>
          <div className="mt-2 flex items-center gap-2 text-xs tracking-[0.18em] uppercase text-white" style={{ textShadow: "0 1px 8px rgba(10, 25, 47, 0.65)" }}>
            <MapPin size={13} className="text-[var(--gold)]" />
            <span>{project.location}</span>
          </div>

          <div className="mt-5 max-h-0 group-hover:max-h-40 overflow-hidden transition-all duration-700 ease-out">
            <p className="text-sm text-white leading-relaxed font-light line-clamp-2" style={{ textShadow: "0 1px 8px rgba(10, 25, 47, 0.6)" }}>
              {project.short_description}
            </p>
            <span className="mt-4 inline-flex items-center gap-1.5 text-[0.7rem] tracking-[0.28em] uppercase text-[var(--gold)]">
              Projeyi İncele <ArrowUpRight size={14} />
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ProjectCard;
